import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useGetCatalogQuery } from '@platform/state/api';
import type { IModuleSummary } from '@platform/core/types';
import { useLabel } from '@platform/hooks/useLabel';
import { ModuleTile } from '@platform/ui';
import { routes } from '@platform/core/lib/routes';
import { moduleNav } from '@platform/navigation';
import type { IRecentModuleChipsProps } from './IRecentModuleChipsProps';

/**
 * «Нещодавні» навігатора модулів (прототип v4 G:L3700): підпис 11px великими літерами і чипи-пігулки 30px — кругла плитка модуля 22px
 * та назва 500; наведення — акцентна рамка. Лише встановлені модулі робочого простору.
 */
export function RecentModuleChips({ ws, keys }: IRecentModuleChipsProps) {
  const { t } = useTranslation();
  const label = useLabel();
  const { data: catalog } = useGetCatalogQuery({ workspaceId: ws });
  const modules = keys.map((key) => catalog?.modules.find((m) => m.key === key && m.installed)).filter((m): m is IModuleSummary => !!m);
  if (!modules.length) return null;
  return (
    <div className="nv-recent">
      <span className="am-section__label">{t('navigator.recent')}</span>
      <div className="nv-recent__chips">
        {modules.map((m) => {
          const nav = moduleNav(m.key);
          return (
            <Link key={m.key} className="nv-chip" to={routes.module(m.key)} data-nav-item="">
              <ModuleTile icon={nav.icon} tone={nav.tone} size={22} raised className="nv-chip__tile" />
              {label(m.name)}
            </Link>
          );
        })}
      </div>
    </div>
  );
}
